import { CertificateData, ExperienceVoucherCertificate } from '@big-red-group/storefront-common-checkout'
import InfoBadge from '@/components/InfoBadge'

type EvParticipantsSumamry = {
  certificates: ExperienceVoucherCertificate[]
}
const EvParticipantsSummary: React.FC<EvParticipantsSumamry> = ({ certificates }) => {
  const generateVoucherText = (certificates: ExperienceVoucherCertificate[]) => {
    if (!certificates?.length) {
      return 'No vouchers available'
    }
    // @ts-ignore
    const groupedTravellers: { [key: string]: ExperienceVoucherCertificate[] } = Object.groupBy(
      certificates,
      (certificate: ExperienceVoucherCertificate) => certificate.productOption?.name ?? ''
    )

    const voucherText = Object.values(groupedTravellers).map((travellers, index, array) => {
      if (!travellers.length) {
        return ''
      }

      const optionName = travellers[0]?.productOption?.name || ''
      const multipleOptions = array.length > 1
      const multipleQuantity = travellers.length > 1
      const isLast = index === array.length - 1
      const isSecondLast = index === array.length - 2

      if (!optionName) {
        return ''
      }

      const conjunction = isLast && multipleOptions ? ' and ' : ''
      const separator = !isLast && !isSecondLast && multipleOptions ? ', ' : ''

      return `${conjunction} ${travellers.length} ${optionName}${multipleQuantity ? 's' : ''}${separator}`
    })

    return voucherText || 'No vouchers included'
  }
  const headingText = `This voucher includes ${generateVoucherText(certificates)}`

  if (!Boolean(certificates?.length)) {
    return null
  }

  return (
    <InfoBadge
      heading={headingText}
      subText="Want to share the fun? Add more friends and family to join at an additional cost"
      iconName="info"
      backgroundColor="#a3a3a333"
      borderColor="#939393"
      textColor="black"
    />
  )
}

export default EvParticipantsSummary
